
<i18n>
{
  "kr": {
    "Personalizable powerful shortcut key support": "수정가능한 강력한 단축키 지원",
    "Many of the functions are available as hotkeys and can be modified to suit individual needs.":
      "대부분의 기능을 이용가능하며 취향에 맞게 수정해서 사용 가능한 강력한 단축키 시스템",

    "Mouse support": "마우스 지원",
    "Various toolbars for easy use": "편리한 사용을 위해 다양한 툴바 지원",

    "Group control": "그룹 다루기",
    "Structure the document by separating / compositing / leveling the group using <b>the Alt + Down/Up/Left/Right keys</b>":
      "<b>alt+down/up/left/right</b>키를 이용하여 그룹을 분리/합성/레벨 조정해서 문서를 구조화하세요.",

    "Text style": "다양한 스타일",
    "Supports various styles such as font color(<span style='color:blue;font-weight:bold'>Ctrl+Alt+B/R/G</span>), bold(<span style='color:blue;font-weight:bold'>Ctrl+B</span>), highlighter":
      "글자 색상(<span style='color:blue;font-weight:bold'>Ctrl+Alt+B/R/G</span>), 굵게(<span style='color:blue;font-weight:bold'>Ctrl+B</span>), 형관펜등 다양한 스타일 지원",

    "Color group box": "색상 박스 지원",
    "Various color group box to emphasize content":
      "내용 강조를 위한 다양한 색상 박스 지원",

    "A table of contents": "목차 구조 지원",
    "Provides a table of contents structure and navigation through it":
      "목차구조를 지원하며, 이를 통한 문서 탐색이 용이합니다.",

    "Memo or note": "메모 or 노트",
    "Selectable for your application<br>Memo - Simple memos based on search<br>Note - systematically arranged note":
      "용도에 맞게<br>메모 - 검색위주 사용이 편리한<br>노트 - 체계적으로 정리가 가능한",

    "Post-it desgin": "심플한 포스트잇",
    "Multiple notes can be opened with a simple post-it design if needed":
     "여러개의 노트를 깔끔한 포스트잇 디자인 창으로 동시에 열수 있습니다.",

    "Group folding": "그룹폴딩",
    "Hide subgroups as needed and focus on important content":
      "필요에 따라서 하위 그룹을 감춰서 중요한 내용에 집중하세요.",

    "__END__":""
  }

}
</i18n>

<template>
  <div>
    <h2>Features</h2>
    <b-container mg="*" class=left>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Personalizable powerful shortcut key support")}}</h4>
        <p v-html="$t('Many of the functions are available as hotkeys and can be modified to suit individual needs.')"></p>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Mouse support")}}</h4>
        <img class="max-width" src="/static/imgs/features/mouse_support.png"><br>
        <span v-html="$t('Various toolbars for easy use')"></span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Group control")}}</h4>
        <img class="max-width" src="/static/imgs/features/group_level.gif"><br>
        <span v-html="$t('Structure the document by separating / compositing / leveling the group using <b>the Alt + Down/Up/Left/Right keys</b>')"></span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Text style")}}</h4>
        <img class="max-width" src="/static/imgs/features/text_style.png"><br>
        <span v-html="$t('Supports various styles such as font color(<span style=\'color:blue;font-weight:bold\'>Ctrl+Alt+B/R/G</span>), bold(<span style=\'color:blue;font-weight:bold\'>Ctrl+B</span>), highlighter')"></span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Color group box")}}</h4>
        <img class="max-width" src="/static/imgs/features/box.gif"><br>
        <span v-html="$t('Various color group box to emphasize content')"></span>
        - <span class='hotkey'>Ctrl+Alt+X</span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("A table of contents")}}</h4>
        <img class="max-width" src="/static/imgs/features/table_content.png"><br>
        <span v-html="$t('Provides a table of contents structure and navigation through it')"></span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Memo or note")}}</h4>
        <img class="max-width" src="/static/imgs/features/memo.png"><br>
        <img class="max-width" style="margin-top: 10px" src="/static/imgs/features/note.png"><br>
        <span v-html="$t('Selectable for your application<br>Memo - Simple memos based on search<br>Note - systematically arranged note')"></span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Post-it design")}}</h4>
        <img class="max-width" src="/static/imgs/features/postit.png"><br>
        <span v-html="$t('Multiple notes can be opened with a simple post-it design if needed')"></span>
        - <span class='hotkey'>Ctrl+Shift+P</span>
      </b-col></b-row>

      <b-row class="margin-item"><b-col>
        <h4>- {{$t("Group folding")}}</h4>
        <img class="max-width" src="/static/imgs/features/folding.gif"><br>
        <span v-html="$t('Hide subgroups as needed and focus on important content')"></span>
        - <span class='hotkey'>Alt+F</span>
      </b-col></b-row>

    </b-container>

  </div>
</template>

<script>
export default {
  name: 'feature-page'
}
</script>

<style lang="css" scoped>

.hotkey {
  color: blue;
  font-weight: bold;
}
.fullfill {
   width: 100%;
}
.max-width {
  max-width:100%;
  width: auto;
}
.left {
  text-align: left;
}
.margin-item { margin-bottom: 30px; }


ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FeaturesPage.vue